<ng-container *transloco="let t">
  <p-toast position="top-right"></p-toast>

  <!-- Skeleton loading state when data is not yet loaded -->
  <div
    class="uploadDocuments"
    *ngIf="isLoading">
    <div class="uploadDocuments__header">
      <p-skeleton
        height="3rem"
        width="80%"
        styleClass="mb-2"></p-skeleton>
      <p-skeleton
        height="1.5rem"
        width="90%"
        styleClass="mb-2"></p-skeleton>
    </div>

    <div class="uploadDocuments__policyNo">
      <p-skeleton
        height="1.5rem"
        width="50%"
        styleClass="mb-4"></p-skeleton>
    </div>

    <div class="uploadDocuments__uploadContainer">
      <div class="skeleton-boxes">
        <div
          class="skeleton-box"
          *ngFor="let i of [1, 2, 3]">
          <p-skeleton
            shape="rectangle"
            height="420px"
            width="100%"
            styleClass="mb-2"></p-skeleton>
        </div>
      </div>
    </div>

    <div class="uploadDocuments__footer">
      <p-skeleton
        height="1.5rem"
        width="90%"
        styleClass="mb-2"></p-skeleton>
      <p-skeleton
        height="1.5rem"
        width="70%"
        styleClass="mb-2"></p-skeleton>
      <p-skeleton
        height="1.5rem"
        width="80%"></p-skeleton>
    </div>
  </div>

  <!-- Actual content when data is loaded -->
  <div
    class="uploadDocuments"
    *ngIf="!isLoading">
    <div class="uploadDocuments__header">
      <h1 class="p-text-uppercase">
        {{ documentsHeader1
        }}<span
          [ngClass]="{ textYellow: !isWarrantyGap, textGreen: isWarrantyGap }"
          >{{ documentsHeader2 }}</span
        >
      </h1>
      <p class="uploadDocuments__header__note textBlue">
        {{ t('documentsUpload.note1') }}
        <span
          [ngClass]="{ textYellow: !isWarrantyGap, textGreen: isWarrantyGap }"
          >{{ t('documentsUpload.note2') }}</span
        >
        {{ t('documentsUpload.note3') }}
      </p>
    </div>

    <div class="uploadDocuments__policyNo">
      <p class="p-text-uppercase textBlue">
        {{ t('documentsUpload.policyNo')
        }}<span
          [ngClass]="{ textYellow: !isWarrantyGap, textGreen: isWarrantyGap }"
          >{{ policyNo }}</span
        >
      </p>
    </div>

    <div class="uploadDocuments__uploadContainer">
      <ng-container *ngFor="let documentBox of documentBoxes">
        <app-documents-upload-box
          [documentBox]="documentBox"
          [policyNo]="policyNo"
          [isWarranty]="isWarrantyGap"
          (documentUploaded)="checkUploadStatus()"
          (documentRemoved)="checkUploadStatus()"></app-documents-upload-box>
      </ng-container>
    </div>

    <div class="uploadDocuments__footer textBlue">
      <p class="uploadDocuments__footer__note">
        <span class="p-text-bold">{{
          t(
            isWarrantyGap
              ? 'documentsUpload.footer.note1Warranty'
              : 'documentsUpload.footer.note1'
          )
        }}</span
        ><br />
        <span>{{
          t(
            isWarrantyGap
              ? 'documentsUpload.footer.note2Warranty'
              : 'documentsUpload.footer.note2'
          )
        }}</span>
        <a
          routerLink="buy-gap"
          [ngClass]="{ textYellow: !isWarrantyGap, textGreen: isWarrantyGap }"
          class="p-text-bold"
          >{{
            t(
              isWarrantyGap
                ? 'documentsUpload.footer.note2LinkWarranty'
                : 'documentsUpload.footer.note2Link'
            )
          }}</a
        >,
        <span>{{
          t(
            isWarrantyGap
              ? 'documentsUpload.footer.note3Warranty'
              : 'documentsUpload.footer.note3'
          )
        }}</span>
      </p>
      <p
        class="uploadDocuments__footer__note uploadDocuments__footer__note--wide">
        {{
          t(
            isWarrantyGap
              ? 'documentsUpload.footer.note4Warranty'
              : 'documentsUpload.footer.note4'
          )
        }}
      </p>
    </div>
  </div>
</ng-container>
